import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId, ISelectItem } from '~/types/models'
import type { IOrderMasterService } from '~/types/order/models'

const apiEntityPath = '/api/ordermasterservices'

export async function getCompanyFromOrderMasterService(id: TEntityId) {
  const callingMn = getCompanyFromOrderMasterService.name
  const apiPath = `${apiEntityPath}/${id}/company`
  return httpGet<IOrderMasterService>({ callingMn, apiPath })
}

export async function getOrderFromOrderMasterService(id: TEntityId) {
  const callingMn = getOrderFromOrderMasterService.name
  const apiPath = `${apiEntityPath}/${id}/order`
  return httpGet<IOrderMasterService>({ callingMn, apiPath })
}

export async function createOrderMasterService(entity: IOrderMasterService) {
  const callingMn = createOrderMasterService.name
  const apiPath = apiEntityPath
  return httpPost<IOrderMasterService>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function getSuppliersFromOrderMasterService(
  id: TEntityId,
  onlyWithReadyForContractMSServices: boolean = false
) {
  const callingMn = getSuppliersFromOrderMasterService.name
  const apiPath =
    `${apiEntityPath}/${id}/suppliers` +
    (onlyWithReadyForContractMSServices
      ? '?onlywithreadyforcontractmsservices=true'
      : '')
  return httpGet<IOrderMasterService>({ callingMn, apiPath })
}

export async function updateOrderMasterService(
  entityData: Partial<IOrderMasterService>,
  id: TEntityId
) {
  const callingMn = updateOrderMasterService.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIOrderMasterService = Partial<IOrderMasterService>
  return httpPatchMerge<TPartialIOrderMasterService>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOrderMasterService(
  entityData: IOrderMasterService
) {
  const callingMn = deleteOrderMasterService.name
  const apiPath = apiEntityPath
  return httpDelete<IOrderMasterService>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function getPotentialLocationSelectItemsForServicesOfOrderMasterService(
  id: TEntityId
) {
  const callingMn =
    getPotentialLocationSelectItemsForServicesOfOrderMasterService.name
  const apiPath = `${apiEntityPath}/${id}/potentiallocations`
  return httpGet<ISelectItem[]>({
    callingMn,
    apiPath,
  })
}
